var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPremium = function SvgPremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.48.75 3.332 3.433 1.187.75A.668.668 0 0 0 0 1.167v10c0 .735.598 1.333 1.333 1.333h9.334c.735 0 1.333-.598 1.333-1.333v-10A.668.668 0 0 0 10.813.75L8.667 3.433 6.52.75c-.254-.316-.788-.316-1.042 0M1.332 11.167V9.833h9.334v1.334zm6.813-6.25c.254.316.788.316 1.042 0l1.479-1.85V8.5H1.333V3.067l1.48 1.85c.254.316.788.316 1.042 0L6 2.234z"
  })));
};
export default SvgPremium;